module.controller('cardContainerCtrl', ['$scope', 'Session', function($scope, Session){
  var giftAmount = Session.getGiftCardAmount();
  var giftPurchasersName = Session.getGiftCardPurchaserName();
  var giftCardMessage = Session.getGiftCardMessage();
  var user = Session.getUser();
  $scope.widgetCards = [];

  var virtualGiftCard = {
    title: 'Hi, Welcome to Akimbo Gift!',
    subTitle: 'Congratulations! You\'ve successfully collected a $' + giftAmount + ' virtual ' +
      $scope.brand.fullGiftProgramName + ' from ' + giftPurchasersName + '. You can begin using your ' +
      'card for online purchases by clicking the "VIEW CARD" button below.',
    message: giftCardMessage,
    image: '/app/assets/images/img-welcome-01.jpg',
    sections: [
      {
        subTitle: '',
        title: 'View your card to make purchases',
        btn: 'VIEW CARD',
        state: 'member.home.virtual.step1'
      }
    ]
  };

  var plasticGiftCard = {
    title: 'Hi, Welcome to Akimbo Gift!',
    subTitle: 'Congratulations! You\'ve successfully collected a $' + giftAmount + ' ' +
      $scope.brand.fullGiftProgramName + ' ' + giftPurchasersName + '. We\'re processing ' +
      'your physical card and you should receive it at the address you provided within 5-8 ' +
      'business days. Once you receive your ' + $scope.brand.fullGiftProgramName + ', you ' +
      'must activate it using the "ACTIVATE" button below.',
    message: giftCardMessage,
    image: '/app/assets/images/img-welcome-01.jpg',
    sections: [
      {
        subTitle: 'REQUIRED',
        title: 'Activate your card to make purchases',
        btn: 'ACTIVATE',
        state: 'member.home.profile/activate.step1'
      }
    ]
  };

  var upgradeGiftCard = {
    title: 'Upgrade Your Account To Access More Features',
    subTitle: 'Click the "UPGRADE" button below.',
    upgradeBlue: true,
    image: '',
    icons: [
      {
        title: 'Get cash at ATMs',
        icon: 'icon-akimbo-atm'
      },
      {
        title: 'Transfer money to/from bank accounts',
        icon: 'icon-akimbo-bank-load'
      },
      {
        title: 'Create Cards for Budgeting and Allowances',
        icon: 'icon-card-sub'
      }
    ],
    sections: [
      {
        subTitle: 'Recommended',
        title: '',
        btn: 'UPGRADE',
        state: 'member.home.upgrade.step1'
      }
    ]
  };

  // this CH has a virtual gift card
  if(user.restrictions.hasOwnProperty('GIFT-RECIPIENT') && !user.restrictions['GIFT-RECIPIENT']){
    $scope.widgetCards.push(virtualGiftCard);
    $scope.widgetCards.push(upgradeGiftCard);
  }

  // this CH has a plastic giftcard
  if(user.restrictions.hasOwnProperty('PGIFT-RECIPIENT') && !user.restrictions['PGIFT-RECIPIENT']){
    $scope.widgetCards.push(plasticGiftCard);
    $scope.widgetCards.push(upgradeGiftCard);
  }

  //$scope.showCards = ($scope.widgetCards.length > 0);
}]);
